






























































import { default as Component } from 'vue-class-component';
import NonCommodityPaymentWidget from '@/components/widgets/NonCommodityPaymentWidget.vue';
import MessagesBlock from '@/components/snippets/messages/MessagesBlock.vue';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    'messages-block': MessagesBlock
  }
})
export default class PaymentWidget extends NonCommodityPaymentWidget {
  @Watch('paymentData.alternativeAccountHolder')
  public alternativeAccountHolderHandler() {
    if (!this.paymentData.alternativeAccountHolder) {
      this.$emit('onPending');
      return;
    }

    if (!this.paymentData.bic) {
      this.$emit('onPending');
      return;
    }

    if (!this.paymentData.bank) {
      this.$emit('onPending');
      return;
    }

    this.$emit('onReady');
  }
  get isErrorAlternativeAccountHolder(): boolean {
    return (
      typeof this.errorElliAlternativeAccountHolder !== 'undefined' && this.errorElliAlternativeAccountHolder !== null
    );
  }
  get errorElliAlternativeAccountHolder(): { key: string; message: string }[] | null {
    return this.getElliError('alternativeAccountHolder');
  }

  get isErrorIban(): boolean {
    return typeof this.errorElliIban !== 'undefined' && this.errorElliIban !== null;
  }
  get errorElliIban(): { key: string; message: string }[] | null {
    return this.getElliError('iban');
  }

  get isErrorBic(): boolean {
    return typeof this.errorElliBic !== 'undefined' && this.errorElliBic !== null;
  }
  get errorElliBic(): { key: string; message: string }[] | null {
    return this.getElliError('bic');
  }

  get isErrorBank(): boolean {
    return typeof this.errorElliBank !== 'undefined' && this.errorElliBank !== null;
  }
  get errorElliBank(): { key: string; message: string }[] | null {
    return this.getElliError('bank');
  }

  get isErrorDirectDebit(): boolean {
    return typeof this.errorElliDirectDebit !== 'undefined' && this.errorElliDirectDebit !== null;
  }
  get errorElliDirectDebit(): { key: string; message: string }[] | null {
    return this.getElliError('directDebit');
  }

  get isErrorDirectDebitConsent(): boolean {
    return typeof this.errorElliDirectDebitConsent !== 'undefined' && this.errorElliDirectDebitConsent !== null;
  }
  get errorElliDirectDebitConsent(): { key: string; message: string }[] | null {
    return this.getElliError('directDebitConsent');
  }

  public getElliError(fieldName: string): [{ key: string; message: string }] | null {
    if (!this.errorsBag) {
      return null;
    }
    if (this.errorsBag[fieldName]) {
      this.hasErrors = true;
      return this.errorsBag[fieldName];
    } else {
      return null;
    }
  }
  public dataModifierHook() {
    return {
      ...this.sessionState,
      genericStorage: null
    };
  }
}
